<template>
  <div class="wrapper box box_v">
    <!-- 头部 -->
    <div class="header-wrapper">
      <div class="tab box">
        <div class="tab1 tab-item" @click="toList">列表</div>
        <div class="tab2 tab-item select">统计</div>
      </div>
      <div class="header">
        <div class="header-text">居民</div>
      </div>
    </div>
    <div class="box_f1 box">
        <user-static-card class="box_f1 card" :title="title[0]" :columnsTitle="columnsTitle1" :icon="icon[0]" countType="score" :orglist="orglist" type="score"></user-static-card>
        <user-static-card class="box_f1 card" :title="title[1]" :columnsTitle="columnsTitle2" :icon="icon[1]" countType="activity" :orglist="orglist" type="signCount"></user-static-card>
        <user-static-card class="box_f1 card" :title="title[2]" :columnsTitle="columnsTitle3" :icon="icon[2]" countType="event" :orglist="orglist" type="reportCount"></user-static-card>
    </div>



  </div>
</template>
<script>
import userStaticCard from "./components/userStaticCard";
var that;
export default {
  data() {
    return {
      title:['居民积分排行','居民活动排行','事件办理排行'],
      icon:['icon-jifen2','icon-huodong4','icon-shijianbanli'],
      orglist:[],
      columnsTitle1:[
          {
              title: ' ',
              key: 'index',
              align: 'center',
          },
          {
              title: '姓名',
              key: 'userName',
              align: 'center',
          },
          // {
          //     title: '属性',
          //     key: 'userAttr',
          //     align: 'center',
          // },
          {
              title: '积分',
              key: 'score',
              // sortable: 'custom',
              filters:[{
                label:'从多到少',
                value:"DESC"
              },{
                label:'从少到多',
                value:"ASC"
              }],
              filterMultiple: false,
              filteredValue:['DESC'],
              filterRemote:function(value, row) {
                console.log('parent')
                this.filterRemote('score',value[0])


              },
              align: 'center',
          }
      ],
      columnsTitle2:[
          {
              title: ' ',
              key: 'index',
              align: 'center',
          },
          {
              title: '姓名',
              key: 'userName',
              align: 'center',
          },
          // {
          //     title: '属性',
          //     key: 'userAttr',
          //     align: 'center',
          // },
          {
              title: '签到数',
              key: 'signCount',
              // sortable: 'custom',
              filters:[{
                label:'从多到少',
                value:"DESC"
              },{
                label:'从少到多',
                value:"ASC"
              }],
              filterMultiple: false,
              filterRemote:function(value, row) {
                console.log('parent')
                console.log(value[0])
                this.filterRemote('signCount',value[0],0)


              },
              filteredValue:['DESC'],
              align: 'center',
          },{
              title: '报名数',
              key: 'applyCount',
              // sortable: 'custom',
              filters:[{
                label:'从多到少',
                value:"DESC"
              },{
                label:'从少到多',
                value:"ASC"
              }],
              filterMultiple: false,
              filterRemote:function(value, row) {
                console.log('parent')
                this.filterRemote('applyCount',value[0],1)


              },
              align: 'center',
          }
      ],
      columnsTitle3:[
          {
              title: ' ',
              key: 'index',
              align: 'center',
          },
          {
              title: '姓名',
              key: 'userName',
              align: 'center',
          },
          // {
          //     title: '属性',
          //     key: 'userAttr',
          //     align: 'center',
          // },
          {
              title: '上报数',
              key: 'reportCount',
              // sortable: 'custom',
              filters:[{
                label:'从多到少',
                value:"DESC"
              },{
                label:'从少到多',
                value:"ASC"
              }],
              filterMultiple: false,
              filterRemote:function(value, row) {

                this.filterRemote('reportCount',value[0])


              },
              filteredValue:['DESC'],
              align: 'center',
          },{
              title: '办理数',
              key: 'executeCount',
              // sortable: 'custom',
              filters:[{
                label:'从多到少',
                value:"DESC"
              },{
                label:'从少到多',
                value:"ASC"
              }],
              filterMultiple: false,
              filterRemote:function(value, row) {
                this.filterRemote('executeCount',value[0])
              },
              align: 'center',
          }
      ],
    };
  },
  created() {
    console.log('--------userStatic-------')
    this.getOrgAll()
  },
  mounted() {

  },
  destroyed() {

  },
  methods: {
    toList(){
      //打开居民列表
      this.$router.replace({ name: "userCitizen" });
    },
    filterRemote(){
      console.log('-----zheli ---------')
    },
    /**查询行政区域 */
    getOrgAll(){
        let url = this.urlobj.getOrgAll;
        this.$get(url, {})
            .then(res => {
              console.log('cimmunityId3:'+this.$store.state.streetorcommunityid)
                this.orglist = res.rows.map((item,index)=>{
                  
                    // if(item.communityId == this.$store.state.streetorcommunityid){
                    //     this.showname[0] = item.communityName
                    //     this.showIndex[0] = index
                    // } 
                    return {
                        communityId:item.communityId,
                        communityName:item.communityName,
                        isSelect: item.communityId == this.$store.state.streetorcommunityid?true:false,
                    }
                    
                })
                
                console.log('--------走到了这里--------')
                console.log(this.orglist)
                //this.getUserStatics()
            })
            .catch(e=>{
            })
    },
  },
  components: {
   userStaticCard
  }
};


</script>

<style lang="less" scoped>
/* 头部信息 开始 */
.wrapper {
  color: #666666;
  min-height: 100%; // 强制滚动
  overflow-x: scroll
  // margin-right: -17px;
}

.header-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
  position: relative;
}
.header {

  width: 98%;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 100px auto 100px;
  justify-items: center;
  align-items: center;

  font-size: 25px;
  .header-text {
    grid-column: 2;
    font-size: 25px
  }
  .header-btn {
    grid-column: 3;
    background-color: #ff7b43;
    line-height: 1;
  }
}
/* 头部信息 结束 */

/*tab切换*/
.tab {
  position: absolute;
  left: 20px;
  background: #fff;
  color: #a0a0a0;
  border-radius: 5px;
  font-size: 14px
}
.tab1 {
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
.tab2 {
  /*background: #ff7b44;*/
  /*color:#fff*/
  // border-right: 1px solid #eee;
  // border-left: 1px solid #eee;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}
.tab3 {
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}
.tab-item {
  //width: 50px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  cursor: default;
  padding:0 15px;
}
.select {
  background: #ff7b44;
  color: #fff;
}
/*tab切换*/

/**卡片*/
.card{
  width: 100%;
  min-width:450px;
  background-color: #fff;
  margin-right: 20px;
  margin-bottom:20px;
}
.card:first-child{
  margin-left: 20px;
}


/*表格*/
th{
    background-color: #ff7745 !important;
}
</style>

